import React, { useState } from 'react';
import { Card, CardContent } from '../../ui/card';
import { GraduationCap, BookOpen, User, ClipboardCheck, LayoutDashboard } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import AcademyCatalog from './AcademyCatalog';
import AcademyMyTrainings from './AcademyMyTrainings';
import AcademyValidationQueue from './AcademyValidationQueue';
import AcademyManagerDashboard from './AcademyManagerDashboard';

const AcademyTab = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.is_admin === true;
  const [view, setView] = useState('catalog');
  const [refreshKey, setRefreshKey] = useState(0);
  const bump = () => setRefreshKey((k) => k + 1);

  const tabs = [
    { id: 'catalog', label: 'Catalogue', icon: BookOpen },
    { id: 'my', label: 'Mes formations', icon: User },
    ...(isAdmin
      ? [
          { id: 'manager', label: 'Tableau Manager', icon: LayoutDashboard },
          { id: 'validate', label: 'Validations', icon: ClipboardCheck },
        ]
      : []),
  ];

  return (
    <div className="space-y-4" data-testid="academy-tab">
      <Card>
        <CardContent className="p-5 bg-gradient-to-r from-emerald-50 to-white">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-emerald-600 flex items-center justify-center text-white">
              <GraduationCap className="w-6 h-6" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-slate-900">SADA Academy</h2>
              <p className="text-sm text-slate-500">
                Formations, certificats, progression annuelle et évaluation continue de l&apos;équipe.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="flex flex-wrap gap-2 border-b border-slate-200">
        {tabs.map((t) => {
          const Icon = t.icon;
          const active = view === t.id;
          return (
            <button
              key={t.id}
              onClick={() => setView(t.id)}
              className={`px-4 py-2 rounded-t-lg text-sm font-medium transition-colors flex items-center gap-2 ${
                active
                  ? 'bg-emerald-600 text-white'
                  : 'text-slate-600 hover:bg-emerald-50'
              }`}
              data-testid={`academy-subtab-${t.id}`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>

      {view === 'catalog' && (
        <AcademyCatalog isAdmin={isAdmin} refreshKey={refreshKey} onStartTraining={bump} />
      )}
      {view === 'my' && (
        <AcademyMyTrainings refreshKey={refreshKey} onCertUploaded={bump} />
      )}
      {view === 'manager' && isAdmin && <AcademyManagerDashboard />}
      {view === 'validate' && isAdmin && (
        <AcademyValidationQueue onValidated={bump} />
      )}
    </div>
  );
};

export default AcademyTab;
